import { FetchStore } from "@root/data/lib";
import { SerializedGitHubRepo, GitHubRepo } from "./github-app-model";
import { apiGateway } from "@root/lib/http";
import { API } from "./constants";

export interface GitHubAppParams {
  installationId: string;
  accessTokenId: string;
  githubUserId: string;
}

class GitHubAppStore extends FetchStore<GitHubRepo[], SerializedGitHubRepo[], GitHubAppParams> {
  protected fetchData(params: GitHubAppParams): Promise<SerializedGitHubRepo[]> {
    const data = apiGateway.get<SerializedGitHubRepo[]>(API.GITHUB_REPOSITORIES, {
      params: { installationId: params.installationId },
      headers: { "access-token-id": params.accessTokenId, "github-user-id": params.githubUserId },
    });
    return data;
  }
  protected deserialize(repositories: SerializedGitHubRepo[]): GitHubRepo[] {
    return repositories.map(
      ({ updated_at, clone_url, default_branch, owner, description, ...props }) =>
        new GitHubRepo({
          ...props,
          cloneURL: clone_url,
          defaultBranch: default_branch,
          ownerName: owner!.login,
          description: description || "",
          ownerAvatarURL: owner!.avatar_url,
          updatedAt: new Date(updated_at),
        })
    );
  }
}

export const githubAppStore = new GitHubAppStore();
